import handlePlusQuantity from 'FORMS/handlePlusQuantity';
import handleSubtractQuantity from 'FORMS/handleSubtractQuantity';
// import domElementsFound from 'DOM/domElementsFound';
import processCartWithRecharge from 'SUBSCRIPTIONS/processCartWithRecharge';
import cartContainsSubscriptionProducts from 'SUBSCRIPTIONS/cartContainsSubscriptionProducts';
import { formatMoney } from '@shopify/theme-currency';

const selectors = {
  addButton: '[data-add-quantity]',
  cartControls: '.bottom-controls',
  cartItems: '.cart-items',
  cartRecommendations: '.subscription-promo',
  cartWrapper: '.cart-wrapper',
  checkoutLink: '[data-cart-checkout]',
  drawer: '.drawer-nav',
  subtractButton: '[data-subtract-quantity]',
  tosInput: '[data-tos-input]',
  quantityChangeButton: '.number-input .btn',
  quantityComponent: '.number-input',
};

$(document).ready(function () {
  // Selectors
  var cart_count = '.drawer-nav [data-card-total-item]';
  var cart_total = '.drawer-nav [data-current-total]';
  var cart_total_formatted = '.drawer-nav [data-total-price]';
  var cart_items = '.drawer-nav [data-cart-items]';

  // Whenever drawer is opened, the cart is redrawn
  $('.drawer').on('drawer.opened', function () {
    clearTOSCheckbox();
    setTimeout(function () {
      Shopify.getCart(function (c) {
        buildCart(c);
      });
    }, 0);
  });

  // Whenever an item is added to the shop, open the drawer.
  Shopify.onItemAdded = function () {
    $('.drawer-nav').removeClass('menu-active');
    $('.drawer-nav').addClass('cart-active');

    // Close the modal
    $('.drawer').drawer('open');
  };

  // eslint-disable-next-line no-unused-vars
  Shopify.onCartUpdate = function (line_item) {
    // console.log('item removed');
  };

  const handleQuantityChange = (event) => {
    const target = event.target.closest(selectors.quantityChangeButton);

    if (!target) return;

    const component = target.closest(selectors.quantityComponent);
    const input = component.querySelector('input[type="number"]');
    const isAddButton = target.hasAttribute('data-add-quantity');
    if (isAddButton) {
      handlePlusQuantity(component, event);
    } else {
      handleSubtractQuantity(component, event);
    }
    const id = input.dataset.updateItem;
    const quantity = parseInt(input.value);

    Shopify.changeItem(id, quantity, function () {
      Shopify.getCart(function (c) {
        buildCart(c);
      });
    });
  };

  const addQuantityChangeListener = () => {
    const drawer = document.querySelector(selectors.drawer);

    if (!drawer) return;

    drawer.addEventListener('click', handleQuantityChange);
  };

  function assignEventHandlers() {
    document.querySelectorAll('.drawer-nav [data-remove-item]').forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        Shopify.removeItem(item.dataset.removeItem, function () {
          Shopify.getCart(function (c) {
            buildCart(c);
          });
        });
      });
    });
  }

  function handleCheckoutClick(event) {
    event.preventDefault();
    const target = event.target;

    const tosInput = target.closest(selectors.cartWrapper).querySelector(selectors.tosInput);

    if (tosInput.checked === false) {
      tosInput.focus();
    } else {
      if (cartContainsSubscriptionProducts()) {
        processCartWithRecharge();
      } else {
        window.location = '/checkout';
      }
    }
  }

  function handleTOSClick(event) {
    const input = event.target;
    const checkoutLink = document.querySelector(selectors.checkoutLink);

    if (input.checked === true) {
      checkoutLink.classList.remove('disabled');
    } else {
      checkoutLink.classList.add('disabled');
    }
  }

  function assignCheckoutHandler() {
    // Add listener for terms of service input
    const checkoutLink = document.querySelector(selectors.checkoutLink);
    const tosInput = document.querySelector(selectors.tosInput);

    if (checkoutLink) {
      checkoutLink.addEventListener('click', handleCheckoutClick);
    }

    if (tosInput) {
      tosInput.addEventListener('click', handleTOSClick);
    }
  }

  function updateShipping(cart) {
    var amounts_el = $('[data-fill-bar-shipping-needed]').data();
    var fill_bar_el = $('[data-fill-bar]');
    if (
      amounts_el.fillBarShippingNeeded !== null &&
      typeof amounts_el.fillBarShippingNeeded !== 'undefined' &&
      amounts_el.fillBarShippingNeeded !== ''
    ) {
      var current_total = cart.total_price / 100;
      if (current_total >= amounts_el.fillBarShippingNeeded) {
        fill_bar_el.css('width', '100%');
        $('[data-upsell-message-success]').css('display', 'block');
        $('[data-upsell-message-progress]').css('display', 'none');
      } else {
        fill_bar_el.css('width', (current_total / amounts_el.fillBarShippingNeeded) * 100 + '%');
        $('[data-upsell-message-success]').css('display', 'none');
        $('[data-upsell-message-progress]').text(
          `Spend $${(amounts_el.fillBarShippingNeeded - current_total).toFixed(
            2
          )} more to get Free Shipping`
        );
        $('[data-upsell-message-progress]').css('display', 'block');
      }
    } else {
      fill_bar_el.css('width', '0%');
      $('[data-upsell-message-success]').css('display', 'none');
      $('[data-upsell-message-progress]').css('display', 'none');
    }
  }

  function clearTOSCheckbox() {
    const input = document.querySelector(selectors.tosInput);
    if (!input) return;
    input.checked = false;
  }

  function buildCart(cart) {
    window.wlcrWyldCart = cart;
    $(cart_count).text(cart.item_count);
    $(cart_total).data('currentTotal', cart.total_price);
    $(cart_total_formatted).text(`$${(cart.total_price / 100).toFixed(2)}`);
    $(cart_items).empty();
    cart.items.forEach(function (item) {
      buildCartItem(item);
    });
    if (cart.item_count === 0) {
      $('[data-empty-message]').css('display', 'block');
    } else {
      $('[data-empty-message]').css('display', 'none');
    }
    updateShipping(cart);
    assignEventHandlers();
    setCartItemsHeight();
  }

  function buildCartItem(item) {
    var html = null;
    // debugger
    if (
      item.selling_plan_allocation !== null &&
      typeof item.selling_plan_allocation !== 'undefined' &&
      item.selling_plan_allocation.selling_plan
    ) {
      // This is a subscription item
      var subscription_text = item.selling_plan_allocation.selling_plan.name
      html = `
      <div class="cart-item">
        <div class="image-wrapper">
          <img src="${item.image}" alt="Cart Item - ${item.title}" />
        </div>

        <div class="details">
          <div class="title">
            <h6 style="display:'inline-block';">Subscription - ${subscription_text}</h6>
            <h5>${item.title}</h5>
          </div>
          <div class="quantity-tracker">
            <div class="inline-group number-selector number-input">
              <div class="input-group-prepend">
                  <button class="btn button-3 minus" data-subtract-quantity>
                    <i class="fa fa-minus"></i>
                  </button>
              </div>
              <input class="quantity" min="0" name="quantity" value="${
                item.quantity
              }" type="number" data-update-item="${item.id}">
              <div class="input-group-append">
                <button class="btn button-3 plus" data-add-quantity>
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>
            <h4 class="unit-price">${formatMoney(item.final_line_price)}</h4>
          </div>
        </div>

        <button class="remove-button" data-remove-item="${
          item.id
        }"><span class="desktop">Remove</span><span class="mobile"><i class="fa fa-times"></i></span></button>
      </div>`;
    } else {
      html = `
      <div class="cart-item">
        <div class="image-wrapper">
          <img src="${item.image}" alt="Cart Item - ${item.title}" />
        </div>

        <div class="details">
          <div class="title">
            <h5>${item.title}</h5>
          </div>
          <div class="quantity-tracker">
            <div class="inline-group number-selector number-input">
              <div class="input-group-prepend">
                  <button class="btn button-3 minus" data-subtract-quantity>
                    <i class="fa fa-minus"></i>
                  </button>
              </div>
              <input class="quantity" min="0" name="quantity" value="${
                item.quantity
              }" type="number" data-update-item="${item.id}">
              <div class="input-group-append">
                <button class="btn button-3 plus" data-add-quantity>
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>
            <h4 class="unit-price">${formatMoney(item.final_line_price)}</h4>
          </div>
        </div>

        <button class="remove-button" data-remove-item="${
          item.id
        }"><span class="desktop">Remove</span><span class="mobile"><i class="fa fa-times"></i></span></button>
      </div>`;
    }

    if (html === null) return;

    $(cart_items).append(html);
  }

  function setCartItemsHeight() {
    const cartWrapper = document.querySelector(selectors.cartWrapper);
    const cartItems = document.querySelector(selectors.cartItems);
    const cartControls = document.querySelector(selectors.cartControls);
    const cartRecommendations = document.querySelector(selectors.cartRecommendations);

    if (!cartControls || !cartItems || !cartWrapper || !cartRecommendations) return;

    const recommendationRect = cartRecommendations.getBoundingClientRect();
    const itemsRect = cartItems.getBoundingClientRect();
    const controlsRect = cartControls.getBoundingClientRect();

    if (recommendationRect.bottom < controlsRect.top) return;

    /* Space available from top of cart items to top of controls */
    const availableCartSpace = controlsRect.top - itemsRect.top;
    const itemAndRecHeight = cartItems.offsetHeight + cartRecommendations.offsetHeight;
    const adjustment = itemAndRecHeight - availableCartSpace;
    const newHeight = cartItems.offsetHeight - adjustment;
    cartItems.style.height = `${newHeight}px`;
  }

  setCartItemsHeight();
  assignEventHandlers();
  assignCheckoutHandler();
  addQuantityChangeListener();

  $(window).resize(function () {
    setCartItemsHeight();
  });
});
